import { useEffect } from "react";
import { useGameStore } from "../stores/gameStore";
import { gameBridge } from "../game/GameBridge";

/** Slam-in banner for the beats that should stop the player mid-click (§30). */

const DISMISS_MS = 2600;

/**
 * The banner is cued from the socket layer, which composes both lines in Korean
 * from the structured event — headline vocabulary comes from
 * `i18n/labels`.BANNER_TITLE. This file only draws it.
 *
 * It used to carry its own English-keyed lookup tables. They were dead — the
 * socket layer never emitted the English titles they were keyed on — and they
 * had drifted to a different word for a captured province than the one actually
 * shown ("영토 함락" against the socket's "영토 점령"), so they are gone.
 */

export function WarBanner() {
  const banner = useGameStore((s) => s.banner);
  const clearBanner = useGameStore((s) => s.clearBanner);

  useEffect(() => {
    if (!banner) return;
    if (banner.tone === "war") {
      // The map should flash the nation the headline is about.
      const war = useGameStore
        .getState()
        .events.find(
          (event) =>
            event.type === "WAR_DECLARED" || event.type === "PROVINCE_CAPTURED",
        );
      if (war?.type === "WAR_DECLARED") gameBridge.pulseNation(war.nationId);
      else if (war?.type === "PROVINCE_CAPTURED")
        gameBridge.pulseNation(war.toNationId);
    }
    const timer = window.setTimeout(clearBanner, DISMISS_MS);
    return () => window.clearTimeout(timer);
  }, [banner, clearBanner]);

  if (!banner) return null;

  return (
    <div className={`war-banner war-banner--${banner.tone}`} key={banner.key}>
      <div className="war-banner__inner">
        <div className="war-banner__title">{banner.title}</div>
        {banner.subtitle ? (
          <div className="war-banner__sub">{banner.subtitle}</div>
        ) : null}
      </div>
    </div>
  );
}
